import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './smart-list-delete-dialog.style';

type SmartListDeleteDialogProps = {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
  smartListName: string;
};

export const SmartListDeleteDialog: React.FC<SmartListDeleteDialogProps> = ({
  open,
  isPending,
  onClose,
  onConfirm,
  smartListName,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} fullWidth onClose={!isPending ? onClose : undefined}>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('dialogs.delete-smart-list.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('dialogs.delete-smart-list.body', { name: smartListName })}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          color={Colors.Inherit}
          onClick={onClose}
          disabled={isPending}
        >
          {t('general.labels.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onConfirm}>
          {t('general.labels.delete')}
        </Button>
      </Styled.Interactions>
    </Dialog>
  );
};
